import Preact from 'preact';

var FormStructure = {
    fields: {
        headerLabel: {
            validations: []
        },
        BusType: {
            validations: [
                { type: 'required', message: 'Please enter type of event' }
            ]
        },
        eventDate: {
            validations: [
                { type: 'required', message: 'Please select a date for your event' },
                { type: 'dateinfuture', message: 'Preferred event date must be in the future' }
            ]
        },
        eventextra5: {
            validations: []
        },
        StartTime: {
            validations: [
                { type: 'required', message: 'Please provide a start time' }
            ]
        },
        plannedguestcount: {
            validations: [
                { type: 'required', message: 'Please enter the number of guests' }
            ]
        },
        Notes: {
            validations: []
        },
        Salutation: {
            validations: []
        },
        firstName: {
            validations: [
                { type: 'required', message: 'Please provide a first name' }
            ]
        },
        lastName: {
            validations: [
                { type: 'required', message: 'Please provide a last name' }
            ]
        },
        ClientName: {
            validations: []
        },
        telnumber: {
            validations: [
                { type: 'required', message: 'Please provide a telephone number' },
                { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
            ]
        },
        email: {
            validations: [
                { type: 'required', message: 'Please provide an email' },
                { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
            ]
        },
        Postal: {
            validations: [
                { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' },
                { type: 'required', message: 'Please provide a zip code' },
            ]
        },
        eventextra4: {
            validations: []
        },
    },
    layout: {
        rows: [
            {
                fields: [
                    {
                    type: 'multiple-choice',
                    size: 'Medium',
                    label: 'Type of Event*',
                    options: [
                        { label: 'Wedding', value: 'Wedding' },
                        { label: 'Social Event (non-wedding)', value: 'Social Event (non-wedding)'},
                        { label: 'Corporate Event', value: 'Corporate Event'},
                    ],
                    mapping: 'BusType'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'date-picker',
                    size: 'Medium',
                    label: 'Requested Event Date*',
                    mapping: 'eventDate'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'multiple-choice',
                    size: 'Medium',
                    label: 'Date Flexible',
                    options: [
                        { label: 'Yes', value: 'Yes' },
                        { label: 'No', value: 'No' },
                    ],
                    mapping: 'eventextra5'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'multiple-choice',
                    size: 'Medium',
                    label: 'Requested Event Time*',
                    options: [
                        { label: '7:30 AM', value: '07:30:00' },
                        { label: '8:00 AM', value: '08:00:00' },
                        { label: '8:30 AM', value: '08:30:00' },
                        { label: '9:00 AM', value: '09:00:00' },
                        { label: '9:30 AM', value: '09:30:00' },
                        { label: '10:00 AM', value: '10:00:00' },
                        { label: '10:30 AM', value: '10:30:00' },
                        { label: '11:00 AM', value: '11:00:00' },
                        { label: '11:30 AM', value: '11:30:00' },
                        { label: '12:00 PM', value: '12:00:00' },
                        { label: '12:30 PM', value: '12:30:00' },
                        { label: '1:00 PM', value: '13:00:00' },
                        { label: '1:30 PM', value: '13:30:00' },
                        { label: '2:00 PM', value: '14:00:00' },
                        { label: '2:30 PM', value: '14:30:00' },
                        { label: '3:00 PM', value: '15:00:00' },
                        { label: '3:30 PM', value: '15:30:00' },
                        { label: '4:00 PM', value: '16:00:00' },
                        { label: '4:30 PM', value: '16:30:00' },
                        { label: '5:00 PM', value: '17:00:00' },
                        { label: '5:30 PM', value: '17:30:00' },
                        { label: '6:00 PM', value: '18:00:00' },
                        { label: '6:30 PM', value: '18:30:00' },
                        { label: '7:00 PM', value: '19:00:00' },
                        { label: '7:30 PM', value: '19:30:00' },
                        { label: '8:00 PM', value: '20:00:00' },
                        { label: '8:30 PM', value: '20:30:00' },
                        { label: '9:00 PM', value: '21:00:00' },
                        { label: '9:30 PM', value: '21:30:00' },
                        { label: '10:00 PM', value: '22:00:00' },
                        { label: '10:30 PM', value: '22:30:00' },
                        { label: '11:00 PM', value: '23:00:00' },
                        { label: '11:30 PM', value: '23:30:00' },
                        { label: '12:00 AM (next day)', value: '00:00:00' },
                        { label: '12:30 AM (next day)', value: '00:30:00' },
                        { label: '1:00 AM (next day)', value: '01:00:00' },
                        { label: '1:30 AM (next day)', value: '01:30:00' },
                        { label: '2:00 AM (next day)', value: '02:00:00' },
                        { label: '2:30 AM (next day)', value: '02:30:00' }
                    ],
                    mapping: 'StartTime'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Expected Attendance*',
                    mapping: 'plannedguestcount'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text-area',
                    size: 'Medium',
                    label: 'Any Additional Details about your event?',
                    mapping: 'Notes'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'multiple-choice',
                    size: 'Medium',
                    label: 'Salutation',
                    options: [
                        { label: 'Mr.', value: 'Mr.' },
                        { label: 'Dr.', value: 'Dr.' },
                        { label: 'Mrs.', value: 'Mrs.' },
                        { label: 'Miss.', value: 'Miss.' },
                        { label: 'Ms.', value: 'Ms.' },
                        { label: 'Other', value: 'Other' },
                    ],
                    mapping: 'Salutation'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'First Name*',
                    mapping: 'firstName'
                }, ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Last Name*',
                    mapping: 'lastName'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Company Name',
                    mapping: 'ClientName'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Daytime Phone*',
                    mapping: 'telnumber'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Email Address*',
                    mapping: 'email'
                }, ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Zip/Postal Code*',
                    mapping: 'Postal'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'text',
                    size: 'Medium',
                    label: 'Guest Rooms: Please Explain',
                    mapping: 'eventextra4'
                }
            ]
            },
            {
                fields: [
                    {
                    type: 'submit',
                    size: 'Medium',
                    label: 'SUBMIT'
                }
            ]
            }
        ]
    },
    info: {
        title: 'Vintners Resort Contact Form',
        formId: '721',
        clientKey: '163E5807-1FFF-470E-926E-DDD736C2F2B5',
        appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
        redirectUrl: '',
        submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
        apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
    }
};


export default FormStructure;